export enum EnumTablasIndexedDB {
  DESCONEXION = 'DESCONEXION',
  REDLENTA = 'REDLENTA',
  FECHAS_CONSULTAS = 'FECHAS_CONSULTAS',
  CATALOGO_AI = 'CATALOGO_AI',
  FAVORITOS_AI = 'FAVORITOS_AI'
}
